"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRegistration = void 0;
class CardRegistration {
    cardRegistrationId;
    cardId;
    registrationData;
}
exports.CardRegistration = CardRegistration;
//# sourceMappingURL=CardRegistration.js.map